import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { AppColors } from "@/assets/colors";
import { pxToRem } from "@/util";

interface Select2Props {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
}

export default function Select2({ value, onChange, error, helperText }: Select2Props) {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value); 
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth error={error}>
        <Select
          value={value}
          onChange={handleChange}
          variant="standard"
          inputProps={{ MenuProps: { disableScrollLock: true } }}
          sx={{
            backgroundColor: AppColors.neutral["78"],
            height: pxToRem(40),
            border: "none",
            "&::before, &::after": { border: "none !important" },
          }}
        >
          <MenuItem value="Virtual">Virtual</MenuItem>
          <MenuItem value="Physical">Physical</MenuItem>
        </Select>
        {helperText && (
          <Box sx={{ color: "error.main", fontSize: pxToRem(12), mt: 0.5 }}>
            {helperText}
          </Box>
        )}
      </FormControl>
    </Box>
  );
}
